export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6156.5c74cca4.jpg";